import { PermissionControlledInput } from "permissions/components/input";
import CreateItemButton from "components/buttons/create";
import HeaderPortal from "components/portal/header-portal";

export default function CreateListItemButton({
  rule = "create:*",
  collection,
  children,
}) {
  if (rule && collection)
    return (
      <HeaderPortal>
        <PermissionControlledInput
          rule={rule}
          collection={collection}
          showWhenDisabled={false}
        >
          <CreateItemButton href>{children}</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
    );

  return (
    <HeaderPortal>
      <CreateItemButton href>{children}</CreateItemButton>
    </HeaderPortal>
  );
}
